import baseAPI from "../app/baseAPI";

export const updateProfileReducer= baseAPI.injectEndpoints({
    endpoints(builder) {
        return {
         
            updateResponse: builder.mutation({
            query(params) {
                console.log('prams',params)
              return {
                url: `/user/profile`,
                method: "PUT",
                prefixUrlType:"Profile",
                token: true,
            
                body: {
                  ...params.paramsData,
                },
              };
            },
            keepUnusedDataFor: 5,
            transformResponse: (responseData) => responseData,
          }),
          editResponse: builder.query({
            query() {
              
              return {
                url: `/user/profile`,
                method: "GET",
                token: true,
                prefixUrlType : "Profile",
              };
            },
            keepUnusedDataFor: 5,
            transformResponse: (responseData) => responseData,
          }),
        
        };
      },
    });
export const {
  useUpdateResponseMutation,
  useEditResponseQuery,
 

} = updateProfileReducer;
